module.exports = __webpack_public_path__ + "img/weddings_10_H.782a0fd6.webp";